// src/components/Footer.jsx
import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer style={s.footer}>
      <div style={s.row}>
        <div style={s.copy}>
          © 2026 Dynamic Innovative Solutions LLC. All rights reserved.
        </div>
        <div style={s.links}>
          <Link to="/privacy" style={s.link} className="hover-gold">Privacy</Link>
          <span style={s.sep}>·</span>
          <Link to="/terms" style={s.link} className="hover-gold">Terms</Link>
          <span style={s.sep}>·</span>
          <a href="mailto:help@disdownrange.org" style={s.link} className="hover-gold">Contact</a>
        </div>
      </div>
      <div style={s.disclaimer}>
        DISDownrange is a ballistic data and load development tool. Always verify ballistic
        data against your own equipment. Users are solely responsible for safe and lawful
        firearms use.
      </div>
    </footer>
  )
}

const s = {
  footer: {
    background: '#111',
    borderTop: '1px solid rgba(255,255,255,0.07)',
    padding: '28px 40px 36px',
    fontFamily: "'DM Mono', monospace",
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 16,
    maxWidth: 1100,
    margin: '0 auto',
  },
  copy: {
    fontSize: 11,
    color: '#888',
    letterSpacing: '0.04em',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  link: {
    fontSize: 11,
    color: '#888',
    textDecoration: 'none',
    transition: 'color 0.2s',
    letterSpacing: '0.04em',
  },
  sep: {
    color: '#333',
    fontSize: 11,
  },
  disclaimer: {
    maxWidth: 1100,
    margin: '18px auto 0',
    fontSize: 10,
    color: '#555',
    lineHeight: 1.7,
    letterSpacing: '0.02em',
  },
}
